import { render, staticRenderFns } from "./PassPrime.vue?vue&type=template&id=3343003c&scoped=true&"
import script from "./PassPrime.vue?vue&type=script&lang=js&"
export * from "./PassPrime.vue?vue&type=script&lang=js&"
import style0 from "./PassPrime.vue?vue&type=style&index=0&id=3343003c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3343003c",
  null
  
)

export default component.exports